/** Ref-count body.qc-popup-open so nested / overlapping QC dialogs don't clear it early. */
let depth = 0;

export function acquireQcPopupOpen() {
    depth += 1;
    document.body.classList.add('qc-popup-open');
}

export function releaseQcPopupOpen() {
    depth = Math.max(0, depth - 1);
    if (depth === 0) document.body.classList.remove('qc-popup-open');
}
